import { render, staticRenderFns } from "./service-endpoint-card.vue?vue&type=template&id=47d51699&scoped=true"
import script from "./service-endpoint-card.vue?vue&type=script&lang=js"
export * from "./service-endpoint-card.vue?vue&type=script&lang=js"
import style0 from "./service-endpoint-card.vue?vue&type=style&index=0&id=47d51699&prod&scoped=true&lang=css"
import style1 from "./service-endpoint-card.vue?vue&type=style&index=1&id=47d51699&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d51699",
  null
  
)

export default component.exports